import React from "react";
import './uploadInformation.scss'
import { translateText } from "../../getTranslationsMyProfileUploadDocumentation";

export const UploadInformation = () => {
    return (
        <div className="information-container">
            <div className="information-header">{translateText('infoTitle')}</div>
            <div className="information-content">{translateText('infoBody')}</div>
        </div>
    )
}

